enum ModalLayers {
  FIRST = "layerFirst",
  SECOND = "layerSecond",
  THIRD = "layerThird",
  FORTH = "layerForth"
}

export default ModalLayers;
